"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Property = void 0;
const core_1 = require("flow-connect/core");
class Property extends core_1.Node {
    constructor() {
        super();
    }
    setupIO() {
        this.addTerminals([
            { type: core_1.TerminalType.IN, name: "object", dataType: "any" },
            { type: core_1.TerminalType.IN, name: "key", dataType: "string" },
            { type: core_1.TerminalType.OUT, name: "value", dataType: "any" },
        ]);
    }
    created(options) {
        const { width = 130, name = "Property", style = {}, state = {} } = options;
        this.width = width;
        this.name = name;
        this.style = Object.assign({ rowHeight: 10 }, style);
    }
    process(inputs) {
        if (!inputs[0])
            return;
        this.setOutputs(0, inputs[0][inputs[1]]);
    }
}
exports.Property = Property;
